import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Landmark } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate, money } from "@/lib/format";

export const ClearingCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/clearing").then((r) => setD(r.data)); }, []);
  return (
    <div className="fade-up mt-8 rounded-lg border bg-card" data-testid="clearing-card">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b px-6 py-4">
        <h3 className="flex items-center gap-2 text-lg font-semibold"><Landmark className="h-5 w-5 text-primary" /> Bank payments clearing</h3>
        {d && d.count > 0 && (
          <div className="text-sm text-muted-foreground"><b className="text-foreground" data-testid="clearing-count">{d.count}</b> pending · <b className="num text-foreground" data-testid="clearing-total">{money(d.total_cents)}</b></div>
        )}
      </div>
      {d && !d.count && <div className="px-6 py-8 text-center text-sm text-muted-foreground" data-testid="clearing-empty">No bank payments clearing</div>}
      <ul className="divide-y">
        {d?.items.map((r) => (
          <li key={r.id}>
            <Link to={`/admin/loans/${r.loan_id}`} className="flex flex-wrap items-center justify-between gap-3 px-6 py-3 transition-colors hover:bg-muted/50" data-testid={`clearing-row-${r.id}`}>
              <span className="min-w-0">
                <span className="block font-medium">{r.borrower_name}</span>
                <span className="mono text-xs text-muted-foreground">{r.loan_number} · started {fmtDate(r.started_on)} · {r.business_days} business day{r.business_days === 1 ? "" : "s"}</span>
              </span>
              <span className="flex items-center gap-3">
                {r.stuck && <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-semibold text-red-700" data-testid={`clearing-stuck-${r.id}`}><AlertTriangle className="h-3.5 w-3.5" /> {r.flag}</span>}
                <span className="num font-semibold">{money(r.amount_cents)}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
